import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Tooltip.scss';

/**
 * Reusable Tooltip Component
 * @function Tooltip
 * @param {Object} props
 * @return {ReactElement}
 * @example ./Tooltip.md
 */
const Tooltip = (props) => {
  const {
    arrowPlacement = 'bottom',
    children,
    className,
    contentClassName,
    contentStyle,
    hidden,
    style,
    textClassName,
    textStyle,
  } = props;

  if (hidden) return null;
  return (
    <div className={classNames(styles.tooltip, className)} style={style}>
      <div className={classNames(styles.tooltipContent, contentClassName)} style={contentStyle}>
        <div className={classNames(styles.tooltipArrow, styles[arrowPlacement])} />
        <div className={classNames(styles.tooltipInner, textClassName)} style={textStyle}>
          <div className={styles.contentWrapper}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  hidden: PropTypes.bool.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  contentStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  arrowPlacement: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  textClassName: PropTypes.string,
  textStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default Tooltip;
